/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var layer = _interopDefault(require('../mixin/layer'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var minilo = require('../util/minilo');

/**
 * @vueProps
 */

/**
 * @module tile-layer/layer
 */
var TileLayer = __ol__.layer.Tile;
var props = /** @lends module:tile-layer/layer# */{
  /**
   * Load low-resolution tiles up to `preload` levels.
   * @type {number}
   * @default 0
   */
  preload: {
    type: Number,
    default: 0
  }

  /**
   * @vueMethods
   */
};var methods = /** @lends module:tile-layer/layer# */{
  /**
   * @return {ol.layer.Tile}
   * @protected
   */
  createLayer: function createLayer() {
    return new TileLayer({
      id: this.id,
      minResolution: this.minResolution,
      maxResolution: this.maxResolution,
      opacity: this.opacity,
      visible: this.visible,
      preload: this.preload,
      extent: this.extent,
      zIndex: this.zIndex,
      source: this._source
    });
  }
};

/**
 * Layer that provide pre-rendered, tiled images in grid that are organized by zoom levels for
 * specific resolutions. `vl-tile-layer` component implements a **source container** interface, so it should be
 * used together with tile-like `vl-source-*` components.
 *
 * @title vl-layer-tile
 * @alias module:tile-layer/layer
 * @vueProto
 *
 * @vueSlot default Default slot for `vl-source-*` (tile-like only) components.
 */
var Layer = {
  name: 'vl-layer-tile',
  mixins: [layer],
  props: props,
  methods: methods
};

/**
 * @alias module:tile-layer
 *
 * @example Install
 * import Vue from 'vue'
 * // import module and styles
 * import { TileLayer } from 'vuelayers'
 * // or
 * import TileLayer from 'vuelayers/lib/tile-layer'
 * // import VueLayers styles
 * import 'vuelayers/lib/style.css'
 * // register components
 * Vue.use(TileLayer)
 */
var index = {
  /**
   * Layer that provide pre-rendered, tiled images in grid that are organized by zoom levels for
   * specific resolutions.
   * @alias module:tile-layer/layer
   */
  Layer: Layer,
  /**
   * @param {Vue} Vue
   * @param {VueLayersOptions} [options]
   */
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Layer, options);

    Vue.component(Layer.name, Layer);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/tile-layer/index.js
// module id = 1492
// module chunks = 1